<template>
  <div>
    <h1 class="page-header">{{ $t('leaveInitialBalance.leaveInitialBalance') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-2 col-md-2 col-sm-12">
            <ts-date-picker-input format="YYYY" v-model="dateGenerate.year"></ts-date-picker-input>
            <div class="validate" v-if="errors.has('year')">
              {{ errors.first('year') }}
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12">
            <ts-button outline color="info" :waiting="waiting" @click.prevent="generateLeaveInitialBalance">
              {{ $t('button.generate') }}
            </ts-button>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12">
            <ts-input v-model="search" placeholder="Search​" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'leave_type_name'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.employee.card_id }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.employee.employee_name_en + ' | ' + record.employee.employee_name_kh }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.employee.sex }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.cycle_start_show }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.cycle_stop_show }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.carry_forward_clear_date }}
            </td>
            <td class="text-center">
              {{ record.entitle_balance }}
            </td>
            <td class="text-center">
              {{ record.increment_day }}
            </td>
            <td class="text-center">
              {{ record.adjustment }}
            </td>
            <td class="text-center">
              {{ record.carry_forward }}
            </td>
            <td class="text-center">
              {{ record.carry_forward_used }}
            </td>
            <td class="text-center">
              {{ record.carry_forward_cleared }}
            </td>
            <td class="text-center">
              <a href="#" title="edit" class="mr-2 text-primary" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import FormComponent from './form.vue'

export default {
  name: 'leave-initial-balance',
  components: { FormComponent },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      loadingPreData: false,
      dateGenerate: {
        year: moment().format('YYYY')
      }
    }
  },
  created() {
    this.fetchData(this.dateGenerate)
  },
  computed: {
    columns() {
      return [
        {
          name: this.$t('leaveInitialBalance.employeeId')
        },
        {
          name: this.$t('leaveInitialBalance.employeeName')
        },
        {
          name: this.$t('leaveInitialBalance.sex'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.cycleStart'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.cycleStop'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.carryForwardClearDate'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.entitleBalance'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.incrementDay'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.adjustment'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.carryForward'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.carryForwardUsed'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveInitialBalance.carryForwardCleared'),
          style: 'text-align:center;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1%;' }
      ]
    },
    ...mapState('hr/leaveInitialBalance', ['resources', 'pagination', 'employees', 'leaveTypes']),
    search: {
      get() {
        return this.$store.state.hr.leaveInitialBalance.search
      },
      set(newValue) {
        this.$store.commit('hr/leaveInitialBalance/SET_SEARCH', newValue)
        this.$store.commit('hr/leaveInitialBalance/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/leaveInitialBalance/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async generateLeaveInitialBalance() {
      if (this.resources.length > 0) {
        if (await this.$confirmModal.danger('Are you sure to generate new ? Old data will be lost.')) {
          this.generate()
        }
      } else {
        this.generate()
      }
    },
    generate() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('hr/leaveInitialBalance/store', this.dateGenerate)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData(this.dateGenerate)
          this.waiting = false
        })
        .catch(error => {
          this.waiting = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData,
          year: this.dateGenerate.year
        },
        {
          height: 'auto',
          width: '550px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(record) {
      this.showForm(record)
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    'dateGenerate.year': function(date) {
      this.fetchData(this.dateGenerate)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('hr/leaveInitialBalance/RESET_STATE')
      this.$store.commit('hr/leaveInitialBalance/RECEIVE_EMPLOYEES', [])
      this.$store.commit('hr/leaveInitialBalance/RECEIVE_LEAVE_TYPES', [])
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
